import { useMemo } from 'react';
export const useCustomItemChildProps = ({
  child,
  index,
  option,
  onSelection,
  listItemsRef,
  isActiveIndex,
  visible
}) => {
  return useMemo(() => {
    if (option.type === 'OPTION' && visible) {
      return {
        onClick(event) {
          const parsedChild = child;

          // This could be a breaking change but it is needed because there is no other way to deal with
          const liEvent = event;
          if (typeof parsedChild.props?.onClick !== 'undefined') {
            parsedChild.props?.onClick(liEvent);
          }
          onSelection();
        },
        onKeyDown(event) {
          if (event.key !== 'Enter' && event.key !== 'Space') {
            return;
          }
          const parsedChild = child;

          // This could be a breaking change but it is needed because there is no other way to deal with
          const liEvent = event;
          if (typeof parsedChild.props?.onClick !== 'undefined') {
            parsedChild.props?.onKeyDown?.(liEvent);
          }
          onSelection();
        },
        tabIndex: isActiveIndex ? 0 : -1,
        key: option.id.toString(),
        id: option.id.toString(),
        name: option.label,
        'data-index': index,
        ref(node) {
          if (visible) {
            listItemsRef.current[index] = node;
          }
        }
      };
    }
    return {
      style: {
        display: !visible ? 'none' : undefined
      },
      'aria-hidden': !visible
    };
  }, [child, index, isActiveIndex, listItemsRef, onSelection, visible, option.id, option.label, option.type]);
};